/* Homepage module: species tabs on What's working and on the videos.
   Cart adds, rail arrows and the video player come from ca-species.js,
   which every homepage section also loads. */
(function () {
  'use strict';
  if (window.__caHp) return;
  window.__caHp = true;

  function has(el, tab) {
    if (tab === 'all') return true;
    var list = (el.getAttribute('data-ca-hp-species') || '').split(',');
    return list.indexOf(tab) >= 0;
  }

  function press(chips, chip) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
  }

  function resetRail(root) {
    var rail = root.querySelector('[data-ca-rail]');
    if (rail) rail.scrollLeft = 0;
  }

  // What's working: chips show the cards for one species and swap the
  // "See all" link under the grid.
  document.querySelectorAll('[data-ca-hp-working]').forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hp-tab]'));
    var cards = root.querySelectorAll('[data-ca-hp-card]');
    var more = root.querySelector('[data-ca-hp-more]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var tab = chip.getAttribute('data-ca-hp-tab');
        press(chips, chip);
        cards.forEach(function (card) { card.hidden = !has(card, tab); });
        if (more) {
          var label = chip.getAttribute('data-ca-hp-more-label');
          var url = chip.getAttribute('data-ca-hp-more-url');
          more.hidden = !(label && url);
          if (label && url) { more.textContent = label; more.setAttribute('href', url); }
        }
        resetRail(root);
      });
    });
  });

  // The player loads only when tapped, so nothing autoplays before that.
  document.addEventListener('click', function (e) {
    var player = e.target.closest('[data-ca-hp-video]');
    if (!player || player.querySelector('iframe')) return;
    var id = player.getAttribute('data-ca-hp-video');
    if (!id) return;
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    frame.title = player.getAttribute('aria-label') || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    player.appendChild(frame);
    try { if (window.clarity) window.clarity('event', 'ca_hp_play_video'); } catch (err) {}
  });

  // Videos: one video is featured, the rest sit in the list. A chip narrows
  // both to one species; tapping a list card features that video.
  document.querySelectorAll('[data-ca-hp-videos]').forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hp-tab]'));
    var features = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hp-feature]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hp-vcard]'));
    var moreHead = root.querySelector('[data-ca-hp-morehead]');
    var tab = root.getAttribute('data-ca-hp-default') || 'all';

    function show(featuredKey) {
      var pool = features.filter(function (f) { return has(f, tab); });
      if (!pool.length) pool = features;
      var keys = pool.map(function (f) { return f.getAttribute('data-ca-hp-feature'); });
      if (keys.indexOf(featuredKey) < 0) featuredKey = keys[0];
      features.forEach(function (f) {
        var on = f.getAttribute('data-ca-hp-feature') === featuredKey;
        if (!on) {
          var frame = f.querySelector('iframe');
          if (frame) frame.parentNode.removeChild(frame);
        }
        f.hidden = !on;
      });
      var listed = 0;
      cards.forEach(function (c) {
        var key = c.getAttribute('data-ca-hp-vcard');
        var on = keys.indexOf(key) >= 0 && key !== featuredKey;
        c.hidden = !on;
        if (on) listed += 1;
      });
      if (moreHead) moreHead.hidden = listed === 0;
      resetRail(root);
    }

    show('');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        tab = chip.getAttribute('data-ca-hp-tab');
        press(chips, chip);
        show('');
      });
    });
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        show(card.getAttribute('data-ca-hp-vcard'));
        var feature = root.querySelector('[data-ca-hp-feature]:not([hidden])');
        if (feature && feature.scrollIntoView) feature.scrollIntoView({ block: 'nearest' });
      });
    });
  });
})();

/* Continue fishing: the products this browser viewed (Sleek's
   sleektheme:recently-viewed list, newest first), fetched through the
   search page as this section and shown in the order they were viewed. */
(function () {
  'use strict';
  if (window.__caHpRecent) return;
  window.__caHpRecent = true;
  document.querySelectorAll('[data-ca-recent]').forEach(function (root) {
    if (root.getAttribute('data-ca-recent-done')) return;
    root.setAttribute('data-ca-recent-done', '1');
    var rail = root.querySelector('[data-ca-recent-rail]');
    var url = root.getAttribute('data-ca-recent-url');
    var min = Number(root.getAttribute('data-ca-recent-min')) || 2;
    var limit = Number(root.getAttribute('data-ca-recent-limit')) || 8;
    if (!rail || !url) return;
    var ids = [];
    try { ids = JSON.parse(window.localStorage.getItem('sleektheme:recently-viewed') || '[]'); } catch (err) { ids = []; }
    ids = ids.filter(function (id) { return Number(id) > 0; }).slice(0, limit);
    if (ids.length < min) return;
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    fetch(url + encodeURIComponent(q)).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var box = doc.querySelector('[data-ca-recent-items]');
      if (!box) return;
      var byId = {};
      Array.prototype.forEach.call(box.querySelectorAll('[data-ca-recent-id]'), function (el) { byId[el.getAttribute('data-ca-recent-id')] = el; });
      var n = 0;
      ids.forEach(function (id) { var el = byId[String(id)]; if (el) { rail.appendChild(el); n += 1; } });
      if (n < min) { rail.innerHTML = ''; return; }
      root.hidden = false;
      rail.addEventListener('click', function (e) {
        if (!e.target.closest('a, button')) return;
        try { if (window.clarity) window.clarity('event', 'ca_hp_recent_click'); } catch (err) {}
      });
      try { if (window.clarity) window.clarity('event', 'ca_hp_recent_shown'); } catch (err) {}
    }).catch(function () {});
  });
})();
